import { z } from 'zod';
/**
 * Where the node's own arrows sit in the graph's cross-cutting flows: before
 * the flow with this edge id. Flows above it are checked first. Absent means
 * after every flow.
 */
export const ownArrowsBeforeShape = {
    ownArrowsBefore: z.string().uuid().optional(),
};
//# sourceMappingURL=flow-precedence.js.map